import { getApi, patchApi, postApi, putApi } from "./api";

export const GetUserByRoleId = async (RoleId) => {
    return await getApi(
        `/User/GetPreviousUserByRoleId/${RoleId}`
    );
};
export const addUser = async (userData) => {
    try {
        const response = await postApi(
            "/User/AddUser",
            userData
        );
        return response;

    } catch (error) {
        console(error);
        throw error.response?.data || error.message;
    }
};
export const GetUserById = async (id) => {
    return await getApi(`/User/GetUserById/${id}`);
};
// Update user (PUT)
export const UpdateUser = async (data) => {
    try {
        return await putApi(`/User/UpdateUser`, data);
    } catch (error) {
        console.error(error);
        throw error.response?.data || error.message;
    }
};

// Partial Update user (PATCH)
export const PatchUser = async (id, data) => {
    try {
        return await patchApi(`/User/${id}`, data);
    } catch (error) {
        console.error(error);
        throw error.response?.data || error.message;
    }
};

export const GetUserDetailsByRoleId = async (roleId) => {
    return await getApi(
        roleId
            ? `/User/GetAllUserByRoleId?roleId=${roleId}`
            : `/User/GetAllUserByRoleId`
    );
};
export const GetUserHierarchy = async () => {
    return await getApi(`/User/GetUserHierarchy`);
};